import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3002/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const assessmentToken = localStorage.getItem('assessmentToken');
  const jwtToken = localStorage.getItem('token');

  const isClientFlow = window.location.pathname.includes('/assessment/') ||
                       window.location.pathname.includes('/client-access/');

  if (assessmentToken && isClientFlow) {
    config.headers.Authorization = `Bearer ${assessmentToken}`;
  } else if (jwtToken) {
    config.headers.Authorization = `Bearer ${jwtToken}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAssessmentRoute = window.location.pathname.includes('/assessment/');
      if (!isAssessmentRoute) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
